import { optionalPositiveInteger, optionalTrimmedString } from '../../../lib/routeSearch';
import { AdsTxtRecordType, type AdsTxtRecordsFilter } from './model';

export interface AdsTxtRecordsRouteSearch {
  search?: string;
  types?: string;
  page?: number;
  size?: number;
}

const defaultAdsTxtRecordsFilter: AdsTxtRecordsFilter = {
  searchTerm: '',
  types: [],
  page: 0,
  size: 20,
};

export function adsTxtRecordsRouteSearchSchema(search: Record<string, unknown>) {
  const searchTerm = optionalTrimmedString(search['search']);
  const types = typeof search['types'] === 'string' ? search['types'] : undefined;
  const page = optionalPositiveInteger(search['page']);
  const size = optionalPositiveInteger(search['size']);
  return {
    ...(searchTerm ? { search: searchTerm } : {}),
    ...(types ? { types } : {}),
    ...(page ? { page } : {}),
    ...(size ? { size } : {}),
  } satisfies AdsTxtRecordsRouteSearch;
}

export function parseAdsTxtRecordsRouteSearch(
  search: AdsTxtRecordsRouteSearch,
): AdsTxtRecordsFilter {
  const validTypes = new Set<string>(Object.values(AdsTxtRecordType));
  return {
    searchTerm: search.search ?? '',
    types: commaValues(search.types).filter((value): value is AdsTxtRecordType =>
      validTypes.has(value),
    ),
    page: search.page ? search.page - 1 : 0,
    size: search.size ?? defaultAdsTxtRecordsFilter.size,
  };
}

export function serializeAdsTxtRecordsRouteSearch(
  filter: AdsTxtRecordsFilter,
): AdsTxtRecordsRouteSearch {
  return {
    ...(filter.searchTerm.trim() ? { search: filter.searchTerm.trim() } : {}),
    ...(filter.types.length ? { types: filter.types.join(',') } : {}),
    ...(filter.page ? { page: filter.page + 1 } : {}),
    ...(filter.size !== defaultAdsTxtRecordsFilter.size ? { size: filter.size } : {}),
  };
}

function commaValues(value?: string) {
  return (
    value
      ?.split(',')
      .map((item) => item.trim())
      .filter(Boolean) ?? []
  );
}
